// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"535":"702b9ed1","744":"4be9759c","879":"59eeba07"}[chunkId] + ".js";
};